<div
    class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-bg-[#8d8d8d7d] tw-z-[200] md:tw-grid md:tw-place-items-center tw-flex tw-justify-center"
    *ngIf="showLoader"
>
    <div
        class="tw-px-16 tw-w-[90%] sm:tw-w-[451px] tw-rounded-[32px] tw-h-fit tw-pt-16 tw-pb-14 tw-mt-20 md:tw-mt-0 tw-flex tw-flex-col tw-justify-center tw-items-center"
        style="
            background: linear-gradient(
                180deg,
                #fffbf8 0%,
                rgba(253, 248, 230) 100%
            );
        "
    >
        <div class="tw-pb-12">
            <mat-spinner style="width: 70px; height: 70px"></mat-spinner>
        </div>

        <div class="tw-text-center tw-text-base tw-font-medium">
            {{ "LOADER_MESSAGE" | translate }}
        </div>
    </div>
</div>
